import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import Buttons from "../../../components/Controls/Buttons/Button";
import BackButtons from "../../../components/Controls/Buttons/BackArrowButton";
import Label from "../../../components/Label/Label";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { TextField, MenuItem, InputAdornment } from "@mui/material";
import { invalidIds } from "../../../utility";
import { Autocomplete } from "@mui/material";


const DefinitionPopup = ({
  open,
  onClose,
  formData,
  errors,
  onChange,
  handleSubmit,
  sepcificaitonForm,
  fieldType,
  setFieldType,
  handleAcceptanceValueChange,
  handleDeleteAcceptanceValue,
  handleAddAcceptanceValue,
  handleBlockChange,
  handleDeleteBlock,
  handleAddBlock,
  parameter,
  limitOperation,
  handleSaveAsDraft,
  addTargetData,
  dropdownOption,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);


  const [selectedClass, setSelectedClass] = React.useState(formData?.parameter_class || "");
  const [newClass, setNewClass] = React.useState("");
  const [classError, setClassError] = React.useState("");
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setIsEdit(false);
    onClose();
  };


  const [selectedUom, setSelectedUom] = React.useState(formData?.unit_of_measure || "");
  const [newUom, setNewUom] = React.useState("");
  const [uomError, setUomError] = React.useState("");

  useEffect(() => {
    const uomList = dropdownOption?.metaList?.data?.unit_of_measure || [];
    const currentUom = formData?.unit_of_measure || "";

    const exists = uomList.some((item) => item.name === currentUom);

    if (exists) {
      setSelectedUom(currentUom);
      setNewUom("");
    } else {
      setSelectedUom("");
      setNewUom(currentUom);
    }

    const classList = dropdownOption?.metaList?.data?.parameter_classes || [];
    const currentClass = formData?.parameter_class || "";

    const classExists = classList.some((item) => item.name === currentClass);

    if (classExists) {
      setSelectedClass(currentClass);
      setNewClass("");
    } else {
      setSelectedClass("");
      setNewClass(currentClass);
    }

  }, [open, formData, dropdownOption]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      hideBackdrop
      disableEnforceFocus
      keepMounted={false}
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          right: 5,
          m: 0,
          width: isEdit ? 400 : 500,
          maxHeight: "calc(100% - 160px)",
          height: "100%",
          boxShadow: "none",
          elevation: 0,
          border: "1px solid #ccc",
          p: 1,
          transition: "width 0.3s ease",
        },
      }}
    >
      <>
        {" "}
        <>
          <DialogTitle className="dialog-title">
            <Label
              text={formData.parameter_id ? "Update Parameter" : "Add Parameter"}
              color="#fff"
              fontSize="14px"
              fontWeight="500"
            ></Label>

            <BackButtons onClick={handleClose} />
          </DialogTitle>

          <DialogContent sx={{ padding: 0.5 }}>
            {/* UNIT OPERATION DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Unit Operation *" />

              <Autocomplete
                size="small"
                options={dropdownOption?.metaList?.data?.unit_operations || []}
                getOptionLabel={(option) => option?.name +' ( '+ option.product_name + "-" +option.site_name+  ' )'|| ""}
                value={
                  dropdownOption?.metaList?.data?.unit_operations?.find(
                    (item) => item.id === formData?.unit_op_id
                  ) || null
                }
                onChange={(e, newValue) => {
                  onChange({
                    target: {
                      name: "unit_op_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search Unit Operation"
                    error={!!errors?.unit_op_id}
                    helperText={errors?.unit_op_id}
                  />
                )}
              />
            </Box>

            {/* PHASE DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Phase" />

              <Autocomplete
                size="small"
                options={dropdownOption?.metaList?.data?.phases || []}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  dropdownOption?.metaList?.data?.phases?.find(
                    (item) => item.name === formData?.phase_name
                  ) || null
                }
                onChange={(e, newValue) => {
                  onChange({
                    target: {
                      name: "phase_name",
                      value: newValue?.name || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Search Phase" />
                )}
              />
            </Box>

            {/* TABLE LEVEL DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Table" />

              <Autocomplete
                size="small"
                options={dropdownOption?.metaList?.data?.tables || []}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  dropdownOption?.metaList?.data?.tables?.find(
                    (item) => item.name === formData?.table_level_name
                  ) || null
                }
                onChange={(e, newValue) => {
                  onChange({
                    target: {
                      name: "table_level_name",
                      value: newValue?.name || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Search Table" />
                )}
              />
            </Box>



            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Name *" />
              <TextField
                name="parameter_name"
                fullWidth
                size="small"
                value={formData?.parameter_name}
                onChange={onChange}
                error={!!errors?.parameter_name}
                helperText={errors?.parameter_name}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Description" />
              <TextField
                name="description"
                fullWidth
                size="small"
                value={formData?.description}
                onChange={onChange}
                error={!!errors?.description}
                helperText={errors?.description}
              />
            </Box>



            {/* DATATYPE DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Data Mandatory" />
              <TextField
                select
                name="is_required"
                fullWidth
                size="small"
                value={formData?.is_required}
                onChange={onChange}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Box>


            {/* SOURCE SYSTEM DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Parameter Type *" />
              <TextField
                select
                name="source_system"
                fullWidth
                size="small"
                value={formData?.source_system}
                onChange={onChange}
                error={!!errors?.source_system}
                helperText={errors?.source_system}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Data Entry">Data Entry</MenuItem>
                {/* <MenuItem value="System">Derived</MenuItem> */}
              </TextField>
            </Box>

            {/* UNIT OF MEASURE (Custom Entry Allowed) */}
            {/* UNIT OF MEASURE */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Unit of Measure (UoM)" />

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                {/* Dropdown */}
                <Autocomplete
                  size="small"
                  fullWidth
                  options={dropdownOption?.metaList?.data?.unit_of_measure || []}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    dropdownOption?.metaList?.data?.unit_of_measure?.find(
                      (item) => item.name === selectedUom
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue?.name || "";

                    setSelectedUom(value);
                    setNewUom("");
                    setUomError("");

                    onChange({
                      target: {
                        name: "unit_of_measure",
                        value: value,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search UOM"
                      error={!!uomError}
                      helperText={uomError}
                    />
                  )}
                />

                {/* Custom Entry */}
                <TextField
                  size="small"
                  fullWidth
                  name="unit_of_measure"
                  placeholder="Enter New UOM"
                  value={newUom}
                  error={!!uomError}
                  helperText={uomError}
                  onChange={(e) => {
                    const value = e.target.value.trim();

                    setSelectedUom("");
                    setNewUom(value);
                    const exists = dropdownOption?.metaList?.data?.unit_of_measure.some(
                      (item) => item.name === value
                    );
                    if (exists) {
                      setUomError("Unit already exists");
                    } else {
                      setUomError("");
                      onChange({
                        target: {
                          name: "unit_of_measure",
                          value: value,
                        },
                      });
                    }
                  }}
                />
              </Box>
            </Box>


            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Class" />

              <Box sx={{ display: "flex", gap: 1 }}>

                {/* Dropdown */}
                <Autocomplete
                  size="small"
                  fullWidth
                  options={dropdownOption?.metaList?.data?.parameter_classes || []}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    dropdownOption?.metaList?.data?.parameter_classes?.find(
                      (item) => item.name === selectedClass
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const value = newValue?.name || "";

                    setSelectedClass(value);
                    setNewClass("");
                    setClassError("");

                    onChange({
                      target: {
                        name: "parameter_class",
                        value: value,
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Class"
                      error={!!classError}
                      helperText={classError}
                    />
                  )}
                />

                {/* Custom Entry */}
                <TextField
                  size="small"
                  fullWidth
                  placeholder="Enter New Class"
                  value={newClass}
                  name="parameter_class"
                  error={!!classError}
                  helperText={classError}
                  onChange={(e) => {
                    const value = e.target.value.trim();

                    setSelectedClass("");
                    setNewClass(value);

                    // 🔥 Duplicate Check (case insensitive)
                    const exists = dropdownOption?.metaList?.data?.parameter_classes?.some(
                      (item) => item.name === value
                    );

                    if (exists) {
                      setClassError("Class already exists");
                    } else {
                      setClassError("");
                      onChange({
                        target: {
                          name: "parameter_class",
                          value: value,
                        },
                      });
                    }
                  }}
                />
              </Box>
            </Box>
            {/* DATATYPE DROPDOWN */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, pt: 1 }}>
              <Label text="Data Type*" />
              <TextField
                select
                name="data_type"
                fullWidth
                size="small"
                value={formData?.data_type}
                onChange={onChange}
                error={!!errors?.data_type}
                helperText={errors?.data_type}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="numeric">numeric</MenuItem>
                <MenuItem value="date">Date</MenuItem>
              </TextField>
            </Box>

          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: 1,
              borderTop: "1px solid #ccc",
            }}
          >
            <Buttons
              size="small"
              text={formData.parameter_id ? "Update" : "Submit"}
              onClick={handleSubmit}
              loading={dropdownOption?.addPara?.loading || dropdownOption?.updatePara?.loading}
            />
            {/* <Buttons
              size="small"
              text="Save Draft"
              onClick={handleSaveAsDraft}
              loading={limitOperation?.draftLoader}
            /> */}
            <Buttons
              size="small"
              colors="gray"
              text="Cancel"
              onClick={onClose}
            />
          </DialogActions>
        </>
      </>
    </Dialog>
  );
};

export default DefinitionPopup;
